module.exports = {
      id: "price-marketing-mix-bonaire-usage",
      viewBox: "0 0 141.7 141.7",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#price-marketing-mix-bonaire",
      toString: function () {
        return this.url;
      }
    }